import { render, staticRenderFns } from "./MaintenanceReportDetail.vue?vue&type=template&id=670da87f&scoped=true&"
import script from "./MaintenanceReportDetail.vue?vue&type=script&lang=js&"
export * from "./MaintenanceReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceReportDetail.vue?vue&type=style&index=0&id=670da87f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670da87f",
  null
  
)

export default component.exports